import React from 'react';
import { Badge } from '@mantine/core';
import {
  REVIEW_CATEGORIES,
  type ReviewCategory,
} from '@tinypro-audit/contracts';

export function ReviewCategoryBadge({
  category,
}: {
  category: ReviewCategory;
}) {
  const display = REVIEW_CATEGORIES[category];
  return (
    <Badge
      color={display.color}
      variant="light"
      style={{ whiteSpace: 'normal', height: 'auto', minHeight: 20 }}
    >
      {display.label}
    </Badge>
  );
}
